import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
export default {
  data() {
    return {
      password: '',
      username: ''
    };
  },
  methods: {
    async login() {
      const credentials = btoa(`${this.username}:${this.password}`); // Base64 编码
      try {
        const response = await fetch('/api/manage/check', {
          method: 'GET',
          headers: {
            'Authorization': `Basic ${credentials}`
          },
          credentials: 'include'
        });
        if (response.status === 401) {
          this.$message.error('用户名或密码错误');
        } else if (response.status === 200) {
          // 认证成功，存储认证信息，跳转到管理页面
          this.$store.commit('setCredentials', credentials);
          this.$router.push('/dashboard');
        } else {
          this.$message.error('用户名或密码错误');
        }
      } catch (error) {
        this.$message.error('服务器错误');
      }
    }
  }
};